module.exports = __webpack_public_path__ + "img/banner-right-1280.497e4f98.png";